import React from "react";

/** A titled portfolio section with a hairline rule under the heading. */
export default function Section({ title, children }) {
  return (
    <section className="mt-14">
      <h2 className="border-b border-slate-200 pb-2 text-sm font-semibold uppercase tracking-widest text-slate-500">
        {title}
      </h2>
      <div className="mt-6">{children}</div>
    </section>
  );
}
